<template>
    <v-card class="ma-1"
            
            height="180"
            outlined>
       
        <v-card-title primary-title>
            <div>
                <h3 class="subtitle-1 mb-0">{{title}}</h3>
                <div> {{text}} </div>
            </div>
        </v-card-title>

        <v-card-actions class="card-bottom">
            <v-btn :disabled="disabled_1" text color="primary" flat small v-on:click="$emit('event', {cardId: cardId, action: button1});">{{button1}}</v-btn>
            <v-btn text color="primary" flat small v-if="button2.length > 0" v-on:click="$emit('event', {cardId: cardId, action: button2});">{{button2}}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {

        props: ['cardId', 'title', 'text', 'button1', 'button2', 'disabled_1'],

        data() {
            return {
                baseUrl: process.env.BASE_URL
            };
        },

        computed: {
           
        },

        uiEvent(event) {
            // console.log("uiEvent : " + event);
            // Process events, that do not need store call
            switch (event) {
                case "cancel": // return to landing page
                    this.$router.push({ name: "Landing" });
                    return;
            }

            // Process events, that  need a  call
            this.$store
                .dispatch({
                    type: event,
                    password: this.password
                })
                .then(result => {
                    console.log("Store returned : " + result.code);
                    this.processStoreResult(event, result);
                })
                .catch(error => {
                    console.log("Action FAILED");
                });
        },

        // Heavy nach jeder Eingabe uafgerufen!
        updated: function () {
            this.$nextTick(function () {

            })
        },
       
    };
</script>

<style scoped>

    .card-bottom {
        position: absolute;
        bottom: 0;
    }

</style>
